export default __webpack_public_path__ + "static/media/WarningErrorWhite.408f778f.svg";